const theme = {
  titles: "#0a625f",
  background_color_base: "linear-gradient(152deg, #00d084, #00625f 63%)",
  links: "#00625f",
  button_confirm: "linear-gradient(84deg, #4faf49 1%, #1f9652 100%)",
  text_button: "white",

  sider: "linear-gradient(152deg, #00d084, #00625f 63%)",
  sider_top: "linear-gradient(152deg, #00d084, #00625f 63%)",
  header: "white",
  tag_success: "green",
  tag_processing: "blue",
  tag_error: "red",
  button_save: "rgb(79, 175, 73)",
  button_save_font_color: "white",
};

export default theme;
